/* AZ & CO — the cabinet's boundary line.

   The cabinet is newest-first, so anything added since the reader was last
   here sits at the top. The marker is drawn BELOW that block, as a boundary:
   everything above it is new, everything below was already on the shelf.
   That is how an unread line behaves in a mail client, and it is the only
   reason this section beats a grid for someone coming back.

   It is a full-width flex item, so inserting it breaks the shelf it lands
   in. That is deliberate: the boundary is a real division and should read as
   one, unlike the delivery dates, which are marked in place precisely so
   they do not empty a shelf to announce themselves.

   Whose line is it. Keys are namespaced by customer id, so two people
   sharing a phone do not inherit each other's marker, and signing in does
   not hand you the guest's. A signed-in customer with no local history at
   all - a new phone, a cleared browser - falls back to the date of their
   last order, which Shopify knows and the browser does not. That is the
   difference between a line that follows the customer and one that only
   follows the device.

   Two keys per identity, and the second matters. az-seen is when they were
   last here. az-ref is the figure actually compared against, snapshotted
   once per session. The first version compared against az-seen directly and
   rewrote it on every pagehide, so opening a bottle and coming back moved
   the line to now and erased it - the marker vanished exactly when someone
   was mid-browse. Holding the reference for the session keeps it still until
   they genuinely leave.

   Storage only, nothing leaves the browser, and every read and write is
   wrapped: private windows and blocked site data throw on access rather
   than returning null. */
(function () {
  var root = document.getElementById('drops');
  var body = document.getElementById('drops-list');
  var since = document.getElementById('drops-since');
  if (!root || !body) return;

  var cells = [].slice.call(body.querySelectorAll('.cab-cell'));
  if (!cells.length) return;

  var who = root.getAttribute('data-who') || 'guest';
  var SEEN = 'az-seen:' + who;
  var REF = 'az-ref:' + who;

  function num(v) {
    var n = parseInt(v, 10);
    return isFinite(n) && n > 0 ? n : null;
  }

  var lastOrder = num(root.getAttribute('data-last-order'));

  /* Fixed for the session: reuse this session's reference if it has one,
     otherwise the last visit, otherwise the last order. */
  function reference() {
    var held = null;
    try { held = num(sessionStorage.getItem(REF)); } catch (e) {}
    if (held !== null) return { at: held, from: 'visit' };

    var last = null;
    try { last = num(localStorage.getItem(SEEN)); } catch (e) {}

    var at = last !== null ? last : lastOrder;
    if (at === null) return { at: null, from: null };

    try { sessionStorage.setItem(REF, String(at)); } catch (e) {}
    return { at: at, from: last !== null ? 'visit' : 'order' };
  }

  function stamp() {
    try { localStorage.setItem(SEEN, String(Math.floor(Date.now() / 1000))); } catch (e) {}
  }

  var WORDS = ['no', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
               'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve'];

  function count(n) { return n <= 12 ? WORDS[n] : String(n); }

  function when(sec) {
    try {
      return new Date(sec * 1000)
        .toLocaleDateString(undefined, { day: 'numeric', month: 'long' });
    } catch (e) { return ''; }
  }

  var ref = reference();

  /* No visit and no order means there is no "since" to report. A first-time
     reader gets the cabinet plain, which is the correct amount of nothing. */
  if (!ref.at) { addEventListener('pagehide', stamp); return; }

  var fresh = cells.filter(function (c) { return num(c.getAttribute('data-at')) > ref.at; });

  var tail = ref.from === 'order'
    ? ' since your last order, ' + when(ref.at)
    : ' since you were last here, ' + when(ref.at);

  if (since) {
    since.textContent = fresh.length
      ? count(fresh.length) + (fresh.length === 1 ? ' bottle' : ' bottles') + tail
      : 'Nothing new' + tail;
    since.hidden = false;
  }

  /* A boundary needs something on both sides: if every bottle is new, or
     none is, there is nothing to divide. */
  if (fresh.length && fresh.length < cells.length) {
    var mark = document.createElement('li');
    mark.className = 'cab-mark';
    mark.textContent = 'Here last time';
    body.insertBefore(mark, fresh[fresh.length - 1].nextSibling);
  }

  addEventListener('pagehide', stamp);
})();
